const sortAttributes = (a, b) => {
  if (a.highlighted) {
    return -1;
  } else if (b.highlighted) {
    return 1;
  } else if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  }

  return 0;
};

const genCashPrices = (servicePrices, highlightedAttribute) =>
  (Array.isArray(servicePrices) ? servicePrices : [])
    .map(servicePrice => ({
      name: servicePrice.service_display_name,
      price: servicePrice.price,
      highlighted: servicePrice.service_display_name === highlightedAttribute,
    }))
    .sort(sortAttributes);

export { genCashPrices };
